import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnalyticsEvent } from '../../models/analytics-event.interface';

import { Link } from '@com-delta-omnichannel/aura';
import { Cards, Upgrades } from './models/upgrades.interfaces';

@Component({
  selector: 'idp-upgrades',
  templateUrl: './upgrades.component.html',
  styleUrls: ['./upgrades.component.scss']
})
export class UpgradesComponent {
  @Input() content: Upgrades = {} as Upgrades;

  @Output() upgradeCardClick = new EventEmitter<AnalyticsEvent>();

  constructor() {
    // Constructor intentionally empty
  }

  onUpgradeCardClick(card: Cards, cardIndex: number): void {
    const eventData = {
      id: card.title.replace(/\s+/g, '').toLowerCase(),
      name: card.title || card.link.label || 'Upgrade Card',
      position: cardIndex + 1,
      link: card.link.url
    };

    this.upgradeCardClick.emit({
      eventName: 'upgrade_card_click',
      eventData: JSON.stringify(eventData)
    });
  }

  onViewAllClick(action: Link): void {
    const eventData = {
      id: action.id ?? 'upgrade_view_all',
      name: action.label,
      link: action.url
    };

    this.upgradeCardClick.emit({
      eventName: 'upgrade_view_all',
      eventData: JSON.stringify(eventData)
    });
  }
}
